import React, { PureComponent } from 'react';
import Fragment from 'react-dot-fragment';
import { Loader } from 'react-loaders';

import { getRequest } from '../../../../../../api/ApiService';
import { fetchTeamMetrics } from '../../../../../../api/MetricsService';
import { formatNumber } from '../../../../../../api/PerformanceFeedback';
import { teamsEndpoint } from '../../../../../../api/Teams';
import Auth from '../../../../../../routes/Auth';
import { handleSelectChange, arrayUniqueFilter } from '../../../utils';

import BannerLayout from '../../../layouts/banner';
import AbbreviatedMillionNumberFormat from "../../../../../../components/ui-building-blocks/numbers/AbbreviatedMillionNumberFormat";

import {
  FormulaName,
  FormulaValue
} from '../../../components/ui';

class EPSStep2 extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      loaded: false,
      teamsToShow: [],
      selectedTeamId: 0,
      allTeamsCount: 0,
      averageSellingPrice: 0,
      unitCost: 0,
      grossMargin: 0,
      netIncome: 0,
      shares: 0,
    };
  }

  componentDidMount() {
    this.fetchData();
  }

  fetchData = () => {
    this.setState({
      loaded: false
    });

    const { activeRound, rounds, performanceFeedbacksGame } = this.props;
    const round = rounds.find(i => i.number === activeRound);
    const roundId = round ? round.id : 0;

    getRequest(
      teamsEndpoint()
    ).then(res => {
      const teamsToShowIds = performanceFeedbacksGame.find(i => i.type === "EPS fail").teams.filter(arrayUniqueFilter);

      const teams = res.body;
      const teamsToShow = teams.filter(i => teamsToShowIds.includes(i.id));

      const temporaryId = Auth.getTeamId();
      const team_id = teamsToShowIds.includes(temporaryId)
        ? temporaryId
        : teamsToShowIds[0];

      Promise.all([
        fetchTeamMetrics(team_id, roundId),
        getRequest(`${process.env.REACT_APP_API_URL}team/report/income_statement/?round_number=${activeRound}&team_id=${team_id}`)
      ])
        .then(res => {
          const metrics = res[0];
          const currentRoundMetrics = metrics.find(i => Number(i.round_number) === Number(activeRound));
          const netRevenues = currentRoundMetrics ? Number(currentRoundMetrics.net_revenues || 0) : 0;
          const unitsSold = currentRoundMetrics ? Number(currentRoundMetrics.units_sold || 0) : 0;
          const averageSellingPrice = unitsSold !== 0 ? Math.abs(netRevenues / unitsSold) : 0;
          const shares = currentRoundMetrics ? Number(currentRoundMetrics.shares || 0) : 0;
          const epsReport = currentRoundMetrics ? Number(currentRoundMetrics.earnings_per_share || 0) : 0;

          const incomeStatement = res[1].body;
          const currentRoundIncomeStatement = incomeStatement.find(i => i.round === roundId);
          const costOfSales = currentRoundIncomeStatement ? Number(currentRoundIncomeStatement['Cost of Sales'] || 0) : 0;
          const unitCost = unitsSold !== 0 ? Math.abs(costOfSales / unitsSold) : 0;
          const netIncome = currentRoundIncomeStatement ? Number(currentRoundIncomeStatement['Net Income'] || 0) : 0;

          this.setState({
            loaded: true,
            teamsToShow,
            selectedTeamId: Number(team_id),
            allTeamsCount: teams.length,
            averageSellingPrice,
            unitCost,
            netIncome: netIncome,
            shares,
            epsReport
          })
        })
        .catch(err => { });
    })
      .catch(err => { });
  }

  render() {
    const {
      loaded,
      teamsToShow,
      selectedTeamId,
      allTeamsCount,
      netIncome,
      shares,
      epsReport
    } = this.state;

    const { previousShownErrors, gamesTargets } = this.props;

    const currentRoundMetrics = gamesTargets.find(i => i.round_number === this.props.activeRound);

    const epsMetric = Number(currentRoundMetrics.earnings_per_share || 0);

    return loaded ? (
      <BannerLayout
        section="Why Targets Weren’t Hit"
        subSection="EPS"
        alertText={`${teamsToShow.length} out of ${allTeamsCount} teams did not generate enough profits`}
        previousShownErrors={previousShownErrors}
        paragraph2={(
          <Fragment>
            <p>This team reported earnings per share of <b>{formatNumber(epsReport)}</b>, falling short of the <b>{formatNumber(epsMetric)}</b> target.</p>
            <p><strong>Common Reasons Teams Struggle to Maximize Profits:</strong></p>
            <p><strong>Revenue Challenges:</strong> Lower revenues often stem from issues in the marketing mix or production capacity. For example, weaker product rankings or underperforming machines.</p>
            <p><strong>Operating Margin Pressures:</strong> Margins tend to shrink when selling prices remain fixed while costs rise. This often happens as teams upgrade products to stay competitive, leading to higher expenses without an immediate boost in price.</p>
            <p><strong>High Financing Costs:</strong> Teams that took on significant debt in earlier rounds may now be struggling with repayments. As the focus shifts to profit-driven metrics, the weight of these financing costs becomes more apparent.</p>
          </Fragment>
        )}
        selectorOptions={teamsToShow}
        selectorSelectedOptionId={selectedTeamId}
        onSelectorChange={value => handleSelectChange(value, this.fetchData)}
        visual={(
          <Fragment>
            <FormulaName background="#2DA548">
              Earnings Per Share<br />
              (EPS)
            </FormulaName>
            <FormulaValue fontSize="28px">=</FormulaValue>
            <FormulaValue>
              Net Profits
              <span className='divider' />
              Average Total Shares
            </FormulaValue>
            <FormulaValue fontSize="28px">=</FormulaValue>
            <FormulaValue>
              <AbbreviatedMillionNumberFormat
                value={netIncome}
                prefix="$"
                negativeClass="negative-value"
                floatCount={2}
              />
              <span className='divider' />
              <AbbreviatedMillionNumberFormat
                value={shares}
                negativeClass="negative-value"
                floatCount={2}
              />
            </FormulaValue>
          </Fragment>
        )}
        visualProps={{
          borderColor: '#D5D9DD',
          background: 'rgba(45, 165, 72, 0.12)',
          flexCenter: true,
          gap: '16px',
        }}
      />
    ) : <Loader type="ball-scale-ripple" active />;
  }
}

export default EPSStep2;



// WEBPACK FOOTER //
// ./src/instructor/components/performance-feedback/pages/why-targets-werent-hit/eps/step2.js